/**
 * Created by Pankaj on 05-Dec-2019
 */


import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {RomanEmpireBetLineWinData} from "../initial/RomanEmpireInitialWPController";
import {BitmapTextStyleData} from "./LineSprite";

/**
 * To control Line win amount and shadow.
 */
export class LineWin {
    private _lineWinAmount: LineWinAmount;
    private _lineWinMultiplier: LineWinMultiplier;
    private _lineWinAmountShadow: LineWinAmountShadow;
    private _layer: ScalableLayer;
    private _shadowWidth : number;

    constructor() {
        this.addEventHandler();
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name);
    }

    private addEventHandler() {
        EventHandler.addEventListener(this, RomanEmpireEvents.HIDE_WIN_LINE_AMOUNT, (event: GameEvent) => this.hide());
        EventHandler.addEventListener(this, RomanEmpireEvents.BET_LINES_DRAW_COMPLETED, (event: GameEvent) => this.onBetLineDrawCompleted());
        EventHandler.addEventListener(this, RomanEmpireEvents.SHOW_WIN_BET_LINE_WIN_AMOUNT, (event: GameEvent) => this.setWinAmount(event.params[0], event.params[1], event.params[2]));
    }

    private setWinAmount(isGenieFeatureTriggered : boolean,betLineWinData: RomanEmpireBetLineWinData, isIndividual: boolean = false): void {
        const betLineIndex = betLineWinData.betLineIndex + 1;
        const amt = isGenieFeatureTriggered ? betLineWinData?.amount : betLineWinData?.multipliedAmount;
        const symIndexInMidReel = betLineWinData?.betLine[2];
        amt && (this._lineWinAmount.text = amt.toFixed(2).toString()); // #51
        let midSymY: number = Helper.getSymbolPositions(2, symIndexInMidReel)[1];
        isGenieFeatureTriggered && (this._lineWinMultiplier.text = "x"+ betLineWinData.extraWildMultiplier);
        this.setPosition(new PIXI.Point(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X, midSymY), isGenieFeatureTriggered);
    }

    private onBetLineDrawCompleted() {
        this._lineWinAmount = new LineWinAmount("", {
            fontName: "NumbersWinCountUp",
            fontSize: 15
        }, RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name);

        this._lineWinMultiplier = new LineWinMultiplier("", {
            fontName: "NumbersWinCountUp",
            fontSize: 12
        });

        this._lineWinAmountShadow = new LineWinAmountShadow(new PIXI.Point(this._lineWinAmount.x, this._lineWinAmount.y));
        this._layer.addChild(this._lineWinAmountShadow, this._lineWinAmount, this._lineWinMultiplier);
        this._shadowWidth = this._lineWinAmountShadow.width;
    }

    private setPosition(pos: PIXI.Point, isGenieFeatureTriggered: boolean) {
        this._lineWinAmountShadow.setPosition(pos);
        let totalWidth : number = this._lineWinAmount.width;
        if(isGenieFeatureTriggered){
            totalWidth = (this._lineWinMultiplier.width + this._lineWinAmount.width + 10);
            this._lineWinAmount.x = pos.x - totalWidth * 0.5;
            this._lineWinAmount.y = pos.y - this._lineWinAmount.height * 0.5;
            this._lineWinMultiplier.x = this._lineWinAmount.x + 5;
            this._lineWinMultiplier.setPosition(new PIXI.Point(this._lineWinAmount.x + this._lineWinAmount.width + 10, pos.y));
            this._lineWinMultiplier.show();
        }else{
            this._lineWinAmount.setPosition(pos);
        }
        this._lineWinAmount.show();
        this._lineWinAmountShadow.show();
        const scale : number = Math.max(1, (totalWidth * 2 )/this._shadowWidth);
        this._lineWinAmountShadow.scale.set(scale);
    }

    private hide() {
        this._lineWinAmount.hide();
        this._lineWinAmountShadow.hide();
        this._lineWinMultiplier.hide();
    }
}

/**
 * LineWinAmount class : win amount showed in individual bel line
 */
export class LineWinMultiplier extends PIXI.BitmapText {
    constructor(text: string, style: BitmapTextStyleData) {
        super(text, style);
        this.hide();
    }

    public hide() {
        this.visible = false;
        this.text = "";
    }

    public setPosition(pos: PIXI.Point) {
        this.position.set(pos.x, pos.y - (this.height * 0.35));
    }

    public show() {
        this.visible = true;
    }
}

/**
 * LineWinAmount class : win amount showed in individual bel line
 */
export class LineWinAmount extends PIXI.BitmapText {
    constructor(text: string, style: BitmapTextStyleData, layer: string) {
        super(text, style);
        this.hide();
    }

    public hide() {
        this.visible = false;
        this.text = "";
    }

    public setPosition(pos: PIXI.Point) {
        this.position.set(pos.x - (this.width / 2), pos.y - (this.height / 2));
    }

    public show() {
        this.visible = true;
    }
}


/**
 * LineWinAmountShadow class : create a shadow behind win amount in individual bet line.
 */
export class LineWinAmountShadow extends PIXI.Sprite {
    constructor(position: PIXI.Point) {
        super(GameResources.getTextures("Shadow")[0]);
        this.init(position);
    }

    private init(position: PIXI.Point) {
        this.position.set(position.x, position.y);
        this.alpha = 0.8; // #50
        this.anchor.set(0.5, 0.5);
        this.hide();
    }

    public setPosition(pos: PIXI.Point) {
        this.position.set(pos.x, pos.y);
    }

    public hide() {
        this.visible = false;
    }

    public show() {
        this.visible = true;
    }

}